export const AttachmentErrorModal: string = 'AttachmentErrorModal';
